// extracted by mini-css-extract-plugin
export default {"layout":"StaticPublicPage_layout__aTjgW","main":"StaticPublicPage_main__4fRmB"};